import {useCreateCourseCompletedTaskMutation} from 'src/graphql-generated'

const useCourseCompletedInteraction = () => {
  const [createInteraction] = useCreateCourseCompletedTaskMutation()

  return createInteraction
}

export default useCourseCompletedInteraction
